import React from 'react';

import { EventList } from '../EventList';
import { ContactForm } from '../ContactForm';
import { PaymentForm } from '../PaymentForm';

export function EventsForm({
  config,
  data,
  errors,
  price,
  paymentProgress,
  handleChange,
  handleSelectionChange,
}) {
  return (
    <>
      <div className="sm:mt-0">
        <ContactForm 
          config={config}
          data={data}
          errors={errors}
          handleChange={handleChange} />
      </div>

      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>

      <div className="mt-10 sm:mt-0">
        <EventList
          config={config}
          data={data}
          onSelectionChange={handleSelectionChange}
        />
      </div>

      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>

      <div className="mt-10 sm:mt-0">
        <PaymentForm
          config={config}
          data={data}
          errors={errors}
          handleChange={handleChange}
          price={price}
          paymentProgress={paymentProgress}
        />
      </div>
    </>
  );
}
